import { ACCESSCODEE } from '../types';

export default {
  state: {
    accessCodeQuery: null,
  },
  getters: {},
  mutations: {
    [ACCESSCODEE.SET_ACCESSCODEE_QUERY](state, payload) {
      state.accessCodeQuery = payload;
    },
  },
  actions: {},
};
